import { CommonResponse, CommonResponseList } from "src/model/common";
import { CompanyAggregatedByBOL, CompanyTradeDataBOLs, PortsAggregatedByBOL, TradeDataListTypeResponse, TradeDataMarketAnalyticsWorldMap } from "src/model/tradeData";
import { getRequest } from "src/services/api/http";
import { TypeBuyerSupplier, TypePortData } from "src/utils/constants/enum";
import { URL_ENDPOINT } from "src/utils/constants/service";

export const TradeDataWithoutHSCodeService = {
  getCompanyTransactionAnalytics,
  getCompanyTransactions,
  getCompanyTradeDataHSCodeChart,
  getCompanyTradeDataHSCodeList,
  getCTDBuyerSupplierCountryWorldMap,
  getCTDBuyerSupplierCountryChart,
  getCTDBuyerSupplierCountryList,
  getCTDPortWorldMap,
  getCTDPortChart,
  getCTDPortList,
  getCTDTradingAreaWorldMap,
  getCTDTradingAreaList,
  checkExistCTD,
  getCTDCompetitorWorldMap,
  getCTDCompetitorList,
  getCTDCompetitorChart,
  getAnalyticsBuyersSuppliersList,
  getPOOBuyersSuppliersList,
  getPODBuyersSuppliersList,
}

function getCompanyTransactionAnalytics(query: Record<string, string | number>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.analytics.totalBillOfLadingMonthly
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}
function getCompanyTransactions(query: Record<string, string | number>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.bol.list
  return getRequest(url, query, new CompanyTradeDataBOLs()) as Promise<CompanyTradeDataBOLs>;
}
function getCompanyTradeDataHSCodeChart(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.hsCode.chart
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponse<TypeCompanyTradeDataHSCode>>;
}
function getCompanyTradeDataHSCodeList(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.hsCode.list
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<TypeCompanyTradeDataHSCodeList>>;
}
function getCTDBuyerSupplierCountryWorldMap(params: Record<string, any>) {
  const url = params?.is_buyer_tab ? URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.buyerWorldMap : URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.supplierWorldMap
  return getRequest(url, params, new TradeDataMarketAnalyticsWorldMap()) as Promise<TradeDataMarketAnalyticsWorldMap>;
}
function getCTDBuyerSupplierCountryChart(params: Record<string, any>) {
  const url = params?.is_buyer_tab ? URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.buyerChart : URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.supplierChart
  return getRequest(url, params, new TradeDataMarketAnalyticsWorldMap()) as Promise<TradeDataMarketAnalyticsWorldMap>;
}
function getCTDBuyerSupplierCountryList(params: Record<string, any>) {
  const url = params?.is_buyer_tab ? URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.buyerListTable : URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.supplierListTable
  return getRequest(url, params, new TradeDataListTypeResponse()) as Promise<TradeDataListTypeResponse>;
}
function getCTDCompetitorWorldMap(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.competitor.competitorWorldMap
  return getRequest(url, params, new TradeDataMarketAnalyticsWorldMap()) as Promise<TradeDataMarketAnalyticsWorldMap>;
}
function getCTDCompetitorChart(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.competitor.competitorChart
  return getRequest(url, params, new TradeDataMarketAnalyticsWorldMap()) as Promise<TradeDataMarketAnalyticsWorldMap>;
}
function getCTDCompetitorList(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.competitor.competitorList
  return getRequest(url, params, new TradeDataListTypeResponse()) as Promise<TradeDataListTypeResponse>;
}
function getCTDPortWorldMap(params: Record<string, any>) {
  const url = params?.role === TypePortData.pod ? URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODWorldMap : URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOWorldMap
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<ITradeDataByProportionalPort>>;
}
function getCTDPortChart(params: Record<string, any>) {
  const url = params?.role === TypePortData.pod ? URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODChart : URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOChart
  return getRequest(url, params, new PortsAggregatedByBOL()) as Promise<PortsAggregatedByBOL>;
}
function getCTDPortList(params: Record<string, any>) {
  const url = params?.role === TypePortData.pod ? URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODList : URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOList
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<ITradeDataByProportionalPort>>;
}

function getCTDTradingAreaWorldMap(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.tradingArea.worldMap
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<ICTDAggregatedMapByBOL>>;
}
function getCTDTradingAreaList(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.tradingArea.list
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<ICTDAggregatedMapByBOL>>;
}
function checkExistCTD(params: Record<string, any>) {
  const url = URL_ENDPOINT.tradeDataWithoutHSCode.checkExist
  return getRequest(url, params, new CommonResponse()) as Promise<CommonResponse>;
}

function getAnalyticsBuyersSuppliersList(params: Record<string, any>, type: TypeBuyerSupplier) {
  const url = type === TypeBuyerSupplier.buyer ? URL_ENDPOINT.tradeDataWithoutHSCode.analytics.buyersList : URL_ENDPOINT.tradeDataWithoutHSCode.analytics.suppliersList
  return getRequest(url, params, new CommonResponse()) as Promise<IResponseList<ICTDBuyerSuppliersList>>;
}
function getPOOBuyersSuppliersList(params: Record<string, any>, type: TypeBuyerSupplier, portCode?: string) {
  const url = type === TypeBuyerSupplier.buyer ? URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOBuyersList : URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOSuppliersList
  return getRequest(url.replace("{port_code}", portCode ?? ''), params, new CommonResponse()) as Promise<IResponseList<ICTDBuyerSuppliersList>>;
}
function getPODBuyersSuppliersList(params: Record<string, any>, type: TypeBuyerSupplier, portCode?: string) {
  const url = type === TypeBuyerSupplier.buyer ? URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODBuyersList : URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODSuppliersList
  return getRequest(url.replace("{port_code}", portCode ?? ''), params, new CommonResponse()) as Promise<IResponseList<ICTDBuyerSuppliersList>>;
}

